interface SupportedLangInfo {
    lang: string
    label: string
}

export const supportedLangs_: SupportedLangInfo[] = [
    {lang: 'en', label: 'ENG'},
    {lang: 'ru', label: 'РУС'},
]
